var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "brand-message-block" }, [
    _c("div", { staticClass: "brand-message-block__wrapper" }, [
      _c("img", {
        staticClass: "brand-message-block__image",
        attrs: {
          src: _vm.schema.settings.brandImage,
          alt: _vm.schema.settings.brandImageAlt
        }
      }),
      _c("h1", { staticClass: "brand-message-block__heading" }, [
        _vm._v(_vm._s(_vm.schema.settings.brandMessage))
      ]),
      _vm.schema.settings.ctaURL !== "" && _vm.schema.settings.ctaText !== ""
        ? _c("div", { staticClass: "brand-message-block__cta-wrapper" }, [
            _c(
              "a",
              {
                staticClass: "button button--primary",
                attrs: { href: _vm.schema.settings.ctaURL }
              },
              [
                _c("span", { staticClass: "button__content" }, [
                  _vm._v(_vm._s(_vm.schema.settings.ctaText))
                ])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }